import { toRgba } from '../../../utils/to-rgba/to-rgba.js';
function darken(color, alpha) {
  var _toRgba = toRgba(color),
    r = _toRgba.r,
    g = _toRgba.g,
    b = _toRgba.b,
    a = _toRgba.a;
  var f = 1 - alpha;
  var dark = function dark(input) {
    return Math.round(input * f);
  };
  return "rgba(".concat(dark(r), ", ").concat(dark(g), ", ").concat(dark(b), ", ").concat(a, ")");
}
export { darken };